import { Component, Input } from '@angular/core';
import { InfoField, InfoFieldItem } from '../../../../../components/shared/info-field/info-field';
import { FormatterHelperService } from '../../../../../services/helpers/formatter-helper.service';

@Component({
  selector: 'app-lead-details-ss',
  standalone: true,
  imports: [InfoField],
  templateUrl: './leads-details-ss.html',
  styleUrls: ['../shared/lead-detail-shared.scss'],
})
export class LeadsDetailsSs {
  leadInfo: InfoFieldItem[] = [];
  simulationInfo1: InfoFieldItem[] = [];
  simulationInfo2: InfoFieldItem[] = [];
  simulationInfo3: InfoFieldItem[] = [];
  simulationInfo4: InfoFieldItem[] = [];

  @Input() set details(value: any) {
    if (value) {
      this.mapDetails(value);
    }
  }

  constructor(private readonly formatter: FormatterHelperService) {}

  private mapDetails(details: any): void {
    this.leadInfo = [
      { type: 'text', title: 'Nome', info: details.nome || '-' },
      { type: 'text', title: 'CPF', info: this.formatter.CPF(details.cpf) },
      { type: 'text', title: 'Data de Nascimento', info: this.formatter.data(details.dataNascimento) },
      { type: 'text', title: 'Email', info: details.email || '-' },
      { type: 'text', title: 'Celular', info: this.formatter.celular(details.celular) },
      { type: 'text', title: 'CEP', info: this.formatter.CEP(details.cep) },
      {
        type: 'status',
        title: 'Status',
        info: details.statusDoLead || '-',
        leadId: details.idLead,
        cdSiglaTipo: details.cdSiglaTipo,
      },
      { type: 'text', title: 'DN atual', info: details.dn?.toString() || '-' },
      { type: 'text', title: 'Preferência de contato', info: details.preferenciaContato || '-' },
      { type: 'text', title: 'Data de criação', info: this.formatter.data(details.dataCriacao) },
      { type: 'text', title: 'Origem da simulação', info: details.origemSimulacao || '-' },
    ];

    this.simulationInfo1 = [
      {
        type: 'text',
        title: 'Código da Simulação',
        info: details.codigoSimulacao?.toString() || '-',
      },
      { type: 'text', title: 'Origem da Simulação', info: details.origemSimulacao || '-' },
      { type: 'text', title: 'Data Simulação', info: this.formatter.dataHora(details.disponivelDesde) },
      { type: 'text', title: 'Tipo de Compra', info: details.tipoCompra || '-' },
    ];
    this.simulationInfo2 = [
      { type: 'text', title: 'Marca', info: details.marca || '-' },
      { type: 'text', title: 'Modelo', info: details.modeloGrupo || '-' },
      { type: 'text', title: 'Modelo Completo', info: details.modeloCompleto || '-' },
      { type: 'text', title: 'Versão', info: details.versao || '-' },
      { type: 'text', title: 'Ano Fabricação', info: details.anoFabricacao?.toString() || '-' },
      { type: 'text', title: 'Ano Modelo', info: details.anoModelo?.toString() || '-' },
    ];
    this.simulationInfo3 = [
      { type: 'text', title: 'Prazo', info: details.quantidadeParcelas?.toString() || '-' },
      { type: 'text', title: 'Valor da Mensalidade', info: this.formatter.moeda(details.valorMensalidadeAssinatura) },
    ];
    this.simulationInfo4 = [{ type: 'text', title: 'Observações', info: details.observacoes || '-' }];
  }
}
